export interface AircraftPart {
  id: string;
  name: string;
  x: number;
  y: number;
  view: 'top' | 'front';
}

// Новые типы для API
export interface AircraftPartRequest {
  aircraftPartType: string;
  aircraftPartName: string;
  description?: string;
}

export interface AircraftPartResponse {
  id: number;
  aircraftPartType: string;
  aircraftPartName: string;
  description?: string;
  createdAt: string;
}

export interface Flight {
  id: number;
  flightNumber: string;
  departureAirport: string;
  arrivalAirport: string;
  departureTime: string;
  arrivalTime: string;
}

export interface Car {
  id: number;
  name: string;
  model: string;
}

export interface Status {
  id: number;
  name: string;
}

export interface User {
  id: number;
  name: string;
  surname: string;
}

export interface FormData {
  title: string;
  description: string;
  flightId: number;
  carId: number;
  statusId: number;
  creatorId: number;
  responsibleId: number;
  aircraftParts: AircraftPartRequest[]; // Изменено на массив запросов частей
  priority: 'LOW' | 'MEDIUM' | 'HIGH';
  liquidType?: 'TYPE_1' | 'TYPE_2' | 'TYPE_3';
}

// Константы для типов жидкостей
export const LIQUID_TYPES = {
  TYPE_1: 'TYPE_1',
  TYPE_2: 'TYPE_2', 
  TYPE_3: 'TYPE_3'
} as const;

export const LIQUID_TYPE_LABELS = {
  [LIQUID_TYPES.TYPE_1]: 'Тип 1',
  [LIQUID_TYPES.TYPE_2]: 'Тип 2',
  [LIQUID_TYPES.TYPE_3]: 'Тип 3'
} as const;

export interface ManualFlightData {
  flightNumber: string;
  departureAirport: string;
  arrivalAirport: string;
  departureTime: string;
  arrivalTime: string;
}

// Список частей самолета с их координатами на схеме
export const AIRCRAFT_PARTS: AircraftPart[] = [
  // Вид сверху
  { id: 'left-wing', name: 'Левое крыло', x: 20, y: 50, view: 'top' },
  { id: 'right-wing', name: 'Правое крыло', x: 80, y: 50, view: 'top' },
  { id: 'left-side', name: 'Левый борт', x: 40, y: 50, view: 'top' },
  { id: 'right-side', name: 'Правый борт', x: 60, y: 50, view: 'top' },
  { id: 'fuselage', name: 'Фюзеляж', x: 50, y: 50, view: 'top' },
  { id: 'left-tail', name: 'Левый хвост', x: 10, y: 30, view: 'top' },
  { id: 'right-tail', name: 'Правый хвост', x: 10, y: 70, view: 'top' },
  // Вид спереди
  { id: 'front-left-wing', name: 'Левое крыло (вид спереди)', x: 20, y: 50, view: 'front' },
  { id: 'front-right-wing', name: 'Правое крыло (вид спереди)', x: 80, y: 50, view: 'front' },
  { id: 'front-left-side', name: 'Левый борт (вид спереди)', x: 40, y: 50, view: 'front' },
  { id: 'front-right-side', name: 'Правый борт (вид спереди)', x: 60, y: 50, view: 'front' },
  { id: 'front-fuselage', name: 'Фюзеляж (вид спереди)', x: 50, y: 50, view: 'front' },
  { id: 'front-tail', name: 'Хвост (вид спереди)', x: 50, y: 10, view: 'front' },
  { id: 'front-left-engine', name: 'Левый двигатель', x: 30, y: 75, view: 'front' },
  { id: 'front-right-engine', name: 'Правый двигатель', x: 70, y: 75, view: 'front' },
  { id: 'front-landing-gear', name: 'Центральная стойка шасси', x: 50, y: 85, view: 'front' },
  { id: 'front-left-landing-gear', name: 'Левая стойка шасси', x: 35, y: 85, view: 'front' },
  { id: 'front-right-landing-gear', name: 'Правая стойка шасси', x: 65, y: 85, view: 'front' }
]; 